import React, {Component} from "react"

import BootstrapTable from "react-bootstrap-table-next"

import {
    MetricTable,
    sortNumeric,
    TableTitleBarChart,
    renderLegendsForTable,
    Error
} from "./../../Utils/Utils.js"

const metric = (cell, row, rowIndex, params) => {
    const props = { ...cell, ...params }
    return <MetricTable {...props} />
}

class AdsAll extends Component {

    render() {
        const { data } = this.props

        if (data.hasData === false) {
          return <Error minHeight={360} />
        }

        const trClassFormat = (row, rowIndex) => (
            row.campaign ? 'content-table-bar-chart__highlight' : 'content-table-bar-chart__indent'
        )

        // add unique ids
        data.data.forEach((d, i) => d.id = i);

        const columns = [
          {
            dataField: "name",
            text: "Ad Name",
            style: { width: "500px", minWidth: "500px", textAlign: "left" },
            headerAlign: "left",
            formatter: TableTitleBarChart,
            sort: true,
            // align: "left", // not working
            // expandable: true // there is no such option in v2
          }, {
            dataField: "ctr",
            text: "CTR",
            style: { width: "140px", minWidth: "140px" },
            formatter: metric,
            formatExtraData: { type: "percentage" },
            sort: true,
            sortFunc: sortNumeric
          }, {
            dataField: "cpc",
            text: "CPC",
            style: { width: "140px", minWidth: "140px" },
            formatter: metric,
            formatExtraData: { format: "$0.00a" },
            sort: true,
            sortFunc: sortNumeric
          }, {
            dataField: "cpa",
            text: "CPA",
            style: { width: "140px", minWidth: "140px" },
            formatter: metric,
            formatExtraData: { format: "$0.00a" },
            sort: true,
            sortFunc: sortNumeric
          }, {
            dataField: "total",
            text: "Total Spent",
            style: { width: "140px", minWidth: "140px" },
            formatter: metric,
            formatExtraData: { format: "$0.00a" },
            sort: true,
            sortFunc: sortNumeric
          }
        ];
    
        const defaultSorted = [{
          dataField: 'total',
          order: 'desc'
        }];
    
        return ([
          <div key={'legends'} >
              {renderLegendsForTable()}
          </div>,
          <BootstrapTable 
            keyField="id" 
            data={data.data} 
            columns={columns} 
            rowClasses={trClassFormat}
            //odyContainerClass="table-large-metrics" // there is no such option in v2
            defaultSorted={defaultSorted}
            striped={false}
            hover={false}
            bordered={false}
            />
        ])
    }
}

export default AdsAll
